<template>
  <div>
  <Card>
      <Row>
        <i-col span="24" :md="22">
          <Form ref="searchForm" inline :model="searchForm" :label-width="73" @submit.native.prevent>
            <FormItem label="标签/Image" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入标签/Image" style="min-width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getImageList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="2">
          <Button style="float: right;" @click="addImage" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getImageList"></page>
        </div>
     </Row>
      <Drawer
        title="添加"
        v-model="change"
        width="500"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="80" :rules="ruleValidate">
          <form-item label="镜像仓库" prop="repository">
             <i-input v-model="formItem.repository" placeholder="请输入镜像仓库名"></i-input>
          </form-item>
          <form-item label="标签" prop="tag">
             <i-input v-model="formItem.tag" placeholder="请输入镜像标签"></i-input>
          </form-item>
           <form-item label="DockerFile" prop="dockerfile" >
            <i-input  v-model="formItem.dockerfile" placeholder="Docker File" type="textarea" :autosize="{minRows: 5}"></i-input>
          </form-item>
          <form-item label="项目描述" prop="description" >
            <i-input  v-model="formItem.description" placeholder="请输入描述信息" type="textarea"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getImageList, saveImage, deleteImage, editImage } from '@/api/cloud'
export default {
  name: 'ImageList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '镜像仓库', key: 'repository', align: 'center', minWidth: 100 },
        { title: '标签', key: 'tag', align: 'center', minWidth: 80 },
        { title: 'Image', key: 'image', align: 'center', minWidth: 80 },
        {
          title: '操作',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    title: 'Edit'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editImage(params)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.deleteImage(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      title: 'Delete'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, '删除')
                ])
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      formItem: {
        id: null,
        repository: '',
        tag: '',
        is_product: true,
        description: '',
        dockerfile: ''
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        repository: [{ required: true, message: '仓库不能为空 !', trigger: 'blur' }],
        tag: [{ required: true, message: '标签不能为空 !', trigger: 'blur' }],
        dockerfile: [{ required: true, message: 'dockfile不能为空 !', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getImageList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name
      }
      getImageList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    addImage () {
      this.change = true
    },
    editImage (params) {
      this.formItem.id = params.row.id
      this.formItem.repository = params.row.repository
      this.formItem.tag = params.row.tag
      this.formItem.is_product = params.row.is_product
      this.formItem.description = params.row.description
      this.formItem.dockerfile = params.row.dockerfile
      this.change = true
    },
    deleteImage (id) {
      deleteImage(id).then(res => {
        if (res.status === 204) {
          this.$Message.success('删除镜像(' + id + ')成功')
          this.getImageList()
        } else {
          this.$Message.error('删除镜像(' + id + ')失败')
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = null
      that.repository = null
      that.tag = null
      that.description = null
      that.dockerfile = null
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getImageList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          if (this.formItem.id) {
            editImage(this.formItem).then(res => {
              if (res.data.id > 0) {
                this.change = false
                this.getImageList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            saveImage(this.formItem).then(res => {
              if (res.data.id > 0) {
                this.change = false
                this.getImageList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.getImageList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
